import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../widgets";
import { LabelProperties, useLabelProperties } from "./LabelProperties";

import { DraftLabelComponent } from "./DraftLabelComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Label } from "../../../../widgets/Label";
import { Registry } from "../../../../base/register";

export const LabelComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error } = useLabelProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <Label
        className={className}
        iconClassName="me-1"
        {...properties}>
        {children}
    </Label>
}

Registry.addControl({
    id: "431e5c30-eebe-4931-b426-8a11950f967c",
    name: "Label",
    type: ControlType.Label,
    properties: LabelProperties,
    component: LabelComponent,
    draftComponent: DraftLabelComponent
})
